import React from 'react';
import styles from '../pages/UserDetailsPage.module.css';

const ImageModal = ({ isOpen, imageUrl, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className={styles['image-modal-overlay']} onClick={onClose}>
            <div className={styles['image-modal-content']} onClick={(e) => e.stopPropagation()}>
                <span className={styles['image-modal-close']} onClick={onClose}>&times;</span>
                <img src={imageUrl} alt="Full Size" className={styles['full-size-image']} />
            </div>
        </div>
    );
};

export default ImageModal;
